import {
    getAvatarInitials,
    getAvatarToneClass,
} from '@apps/web/components/ui/user_avatar';
import { cn } from '@apps/web/lib/utils';

type ProfileAvatarProps = {
    readonly entityId: string;
    readonly displayName: string;
    readonly className?: string;
};

/**
 * Circular initials avatar for caregiver/client profile headers.
 */
export function ProfileAvatar({
    entityId,
    displayName,
    className,
}: ProfileAvatarProps) {
    return (
        <span
            className={cn(
                'inline-flex size-8 shrink-0 items-center justify-center rounded-full text-xs font-semibold',
                getAvatarToneClass(entityId),
                className,
            )}
            data-testid="profile-avatar"
            aria-hidden={true}
        >
            {getAvatarInitials(displayName)}
        </span>
    );
}
